const autoNgTemplateLoaderTemplate1 = require('./activity-logs-datatable.html');

import './activity-logs-datatable.css';

import controller from './activity-logs-datatable.controller.js';

export const activityLogsDatatable = {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller,
  bindings: {
    logs: '<',
    keyword: '<',
    sort: '<',
    limit: '<',
    totalItems: '<',
    currentPage: '<',
    feature: '@',

    onChangeContextFilter: '<',
    onChangeKeyword: '<',
    onChangeSort: '<',

    onChangeLimit: '<',
    onChangePage: '<',
  },
};
